// extracted by mini-css-extract-plugin
export default {"main":"VersionEncuestaSelector_main__1K4J4"};